import React, {Component} from "react";
import {
    Alert,
    Button,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
    ModalBody,
    ModalHeader,
} from "reactstrap";
import {Link, withRouter} from "react-router-dom";
//i18n
import {withNamespaces} from "react-i18next";
import {getAccountAlias, getDefaultAvatar} from "../../../helpers/Util";
import {AvField, AvForm} from "availity-reactstrap-validation";
import {delegateAccess, inviteBitgo, refreshToken} from "../../../helpers/auth";
import {getProfile,} from "../../../store/auth/user/actions";
import {connect} from "react-redux";
import {
    getAgentsAction,
    getBdsAction,
    getClientsAction,
    getCustodiansAction,
    getGroupsAction,
    getRiasAction
} from "../../../store/info/actions";
import CardDelegates from "../../../pages/Cards/CardDelegates";
import {getEnvironmentVariables} from "../../../store/actions";

class ProfileMenu extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            menu: false,
            username: "",
            inviteModal: false,
            inviteSuccess: null,
            inviteError: null,
            delegatorMenuOpen: false,
            manageDelegateeModal: false,
            profileMenuOpen: false
        };
        this.toggle = this.toggle.bind(this);
        this.handleInviteSubmit = this.handleInviteSubmit.bind(this);
        this.switchProfile = this.switchProfile.bind(this);
        this.changeTo = this.changeTo.bind(this);
        this.isDelegated = this.isDelegated.bind(this);
        this.getCurRealUser = this.getCurRealUser.bind(this);
    }

    componentDidMount() {
        this.setUsername();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props !== prevProps) {
            this.setUsername();
        }
    }

    setUsername() {
        const authUser = JSON.parse(localStorage.getItem("authUser") || "");
        this.setState({
            username: `${authUser.email.split("@")[0]}${this.isDelegated() ? " (Delegated)" : ""}`
        });
    }

    isDelegated() {
        const authUser = JSON.parse(localStorage.getItem("authUser") || "");
        return !!authUser?.delegated;
    }

    getCurRealUser() {
        const authUser = JSON.parse(localStorage.getItem("authUser") || "");
        const realEmail = authUser?.realEmail || "";
        return <DropdownItem to="#" onClick={() => this.changeTo(realEmail)}>
            <i className="bx bx-user font-size-16 align-middle mr-1"/>{realEmail + " (Owner)"}
        </DropdownItem>;
    }

    toggle(e) {
        if (!e.target.dataset.submenu) {
            this.setState(prevState => ({
                menu: !prevState.menu
            }));
        }
    }

    toggleInviteModal = () => {
        this.setState(prevState => ({
            inviteModal: !prevState.inviteModal
        }));
    };

    toggleDelegateModal = () => {
        this.setState(prevState => ({
            manageDelegateeModal: !prevState.manageDelegateeModal
        }));
        if (this.props.updateDelegateesResponse) this.props.updateDelegateesResponse(null);
    };

    handleInviteSubmit(event, values) {
        this.setState({
            inviteSuccess: null,
            inviteError: null
        });
        let emails = values.emails ? values.emails.split("\n") : [];
        emails = [...new Set(emails)].filter(email => email && email.trim());
        if (emails.length) {
            inviteBitgo({emails}).then(() => {
                this.formRef.current.reset();
                this.setState({
                    inviteSuccess: emails.length + " invite(s) sent.",
                    inviteError: null
                });
            }).catch(err => {
                this.setState({
                    inviteSuccess: null,
                    inviteError: err.message
                });
            });
        }
    }

    switchProfile(profile) {
        refreshToken(profile)
        .then(() => {
            this.swapOrg();
        });
    }

    changeTo(delegator) {
        delegateAccess({
            delegator
        }).then(() => {
            this.swapOrg();
        });
    }

    swapOrg() {
        const authUser = JSON.parse(localStorage.getItem("authUser") || "");
        let org;
        if (authUser.uiHost) {
            org = authUser.uiHost.substring(authUser.uiHost.lastIndexOf("/") + 1);
        }
        if (this.props.org !== org) {
            localStorage.setItem("originalOrg", this.props.org || 1);
        } else {
            localStorage.removeItem("originalOrg");
        }
        if (org) {
            localStorage.setItem("org", org);
        }
        window.location.reload();
    }

    render() {
        const {user, profile, delegators} = this.props;
        const {
            menu,
            username,
            delegatorMenuOpen,
            manageDelegateeModal,
            profileMenuOpen
        } = this.state;
        const isAdmin = user && user.group === "admin";
        const profiles = user?.profiles || [];
        return (
            <React.Fragment>
                <Dropdown isOpen={menu} toggle={this.toggle} className="d-inline-block">
                    <DropdownToggle className="btn header-item waves-effect" id="page-header-user-dropdown"
                                    tag="button">
                        <img className="rounded-circle header-profile-user" src={getDefaultAvatar()}
                             alt="Header Avatar"/>
                        <span className="d-none d-xl-inline-block ml-2 mr-1">{username}</span>
                        <i className="mdi mdi-chevron-down d-none d-xl-inline-block"/>
                    </DropdownToggle>
                    <DropdownMenu right>
                        {!this.isDelegated() && <DropdownItem tag={Link} to="/profile"><i
                            className="bx bx-user font-size-16 align-middle mr-1"/>{this.props.t("Profile")}
                        </DropdownItem>}
                        {profiles.length > 1 && <div>
                            <DropdownItem data-submenu={true}
                                          onClick={() => this.setState({profileMenuOpen: !profileMenuOpen})}>
                                <i data-submenu={true}
                                   className={`bx ${profileMenuOpen ? "bx-minus" : "bx-plus"} font-size-16 align-middle mr-1`}/>
                                <span data-submenu={true}>Switch Profile</span>
                            </DropdownItem>
                            <div className={`${profileMenuOpen ? "" : "hide-height"}`}>
                                {profiles.filter(p => p.group !== user.group || p.id !== user.id).map((profile, index) => (
                                    <DropdownItem key={"profile-" + index} to="#"
                                                  onClick={() => this.switchProfile(profile)}>
                                        <i className="bx bx-user font-size-16 align-middle mr-1"/>{`${profile.id} (${getAccountAlias(profile.group)})`}
                                    </DropdownItem>
                                ))}
                            </div>
                        </div>}
                        {isAdmin && <DropdownItem onClick={() => this.setState({inviteModal: true})}><i
                            className="bx bx-user-plus font-size-16 align-middle mr-1"/>BitGo Invite
                        </DropdownItem>}
                        <div className="dropdown-divider"/>
                        <DropdownItem data-submenu={true}
                                      onClick={() => this.setState({delegatorMenuOpen: !delegatorMenuOpen})}>
                            <i data-submenu={true}
                               className={`bx ${delegatorMenuOpen ? "bx-minus" : "bx-plus"} font-size-16 align-middle mr-1`}/>
                            <span data-submenu={true}>Delegate Access</span>
                        </DropdownItem>
                        <div className={`${delegatorMenuOpen ? "" : "hide-height"}`}>
                            {profile && !this.isDelegated() && <DropdownItem
                                onClick={() => this.setState({manageDelegateeModal: !manageDelegateeModal})}>
                                <i className="bx bx-edit font-size-16 align-middle mr-1"/>Manage Delegatees
                            </DropdownItem>}
                            {this.isDelegated() ? this.getCurRealUser() : ""}
                            {delegators && delegators.length > 0 ?
                                <>
                                    {delegators.filter(d => d.delegator !== user.email).map(dele => (
                                        <DropdownItem key={dele.delegator} to="#"
                                                      onClick={() => this.changeTo(dele.delegator)}>
                                            <i className="bx bx-user font-size-16 align-middle mr-1"/>{dele.delegator + " (Delegated)"}
                                        </DropdownItem>
                                    ))}
                                </>
                                : ""}
                        </div>
                        <div className="dropdown-divider"/>
                        <Link to="/logout" className="dropdown-item">
                            <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"/>
                            <span>{this.props.t("Logout")}</span>
                        </Link>
                    </DropdownMenu>
                </Dropdown>
                {/* Delegate management modal */}
                <CardDelegates toggleDelegateModal={this.toggleDelegateModal} manageDelegateeModal={manageDelegateeModal} />
                {/* Invite Modal */}
                <Modal isOpen={this.state.inviteModal} role="dialog" size="md" autoFocus={true} centered={true}
                       id="bitgoInviteModal">
                    <div className="modal-content">
                        <ModalHeader toggle={this.toggleInviteModal}>BitGo Invite</ModalHeader>
                        <ModalBody>
                            <AvForm ref={this.formRef} className="form-horizontal mt-1"
                                    onValidSubmit={this.handleInviteSubmit}>
                                {this.state.inviteSuccess ?
                                    <Alert color="success">{this.state.inviteSuccess}</Alert> : null}
                                {this.state.inviteError ? <Alert color="danger">{this.state.inviteError}</Alert> : null}
                                <AvField type="textarea" name="emails" rows={10} required
                                         placeholder="Enter a list of email addresses, one per line."/>
                                <div className="mt-4">
                                    <Button color={"primary"} block>
                                        Invite
                                    </Button>
                                </div>
                            </AvForm>
                        </ModalBody>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const {user, profile, delegators, delegatees, delegateesResponse} = state.User;
    const { org } = state.Variables;
    return {user, profile, delegators, delegatees, delegateesResponse, org};
};

export default withRouter(connect(mapStateToProps, {
    getProfile,
    getCustodiansAction,
    getBdsAction,
    getRiasAction,
    getAgentsAction,
    getClientsAction,
    getGroupsAction,
    getEnvironmentVariables
})(withNamespaces()(ProfileMenu)));
